export enum CardioTypes {
    restEcgProcedure,
    restEcgRequest,
}
